export default __webpack_public_path__ + "static/media/header-backet.3d5d80b3.svg";